module.exports = __webpack_public_path__ + "static/hsbc-card-5400c24fc5f48e954263838613b8e1b7.jpeg";